import React from "react";
import "./CaseNotes.scss"
import TabsCarousel from "Components/TabsCarousel";
import ProtectiveFactorScreening from "./ProtectiveFactorScreening";
import DotScreening from "./DotScreening";
import SosScreening from "./SosScreening";
const ButtonLists = [
   
    {label: " Symptoms Of Stress", value:"sos"},
{label: "Protective Factors", value:"protective_factors"},
{label: "DOTS", value:"dot"},
];

 class Stress extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            selectedView:0,
            update_info:false,
            switch_tab:true,
            temptabs_stress:["0"]
        }
        this.renderContent = this.renderContent.bind(this);
        this.form = React.createRef()
    }
    handleDoctorSelection(key,index){
    
        this.setState({selectedView:index})
    }

    renderContent(key){
        switch (key){
          
            case 0:
return(
<>

<SosScreening data={this.props.data} formAction={this.props.formAction} />
</>
)
case 1:
    return(
    <>
     
<ProtectiveFactorScreening data={this.props.data} formAction={this.props.formAction} />
</>)
    case 2:
        return(
        <>
        
        <DotScreening data={this.props.data} formAction={this.props.formAction} />
        </>)
        }
    }
    render() {
       
        return (
            <div className="casenotes-container">
                <div style={{padding: "8px", borderTop: "0.4px dashed lightgrey", backgroundColor:"white"}}>
                   <TabsCarousel data={ButtonLists} selected={this.state.selectedView}
                   style={{background:"#f5f5f5"}}
               disabled={[]}
               handleFunction={this.handleDoctorSelection.bind(this)}        
               formAction={this.props.form_action}               
               render={(item, index) => { 
             return(
               <div className={`card-container tab-pane`}> 
               <p>{item.label}</p>
               </div>)}} />
               </div>
           <div style={{background:"white",marginTop:"0px"}} className="tab-content stress-content">
            {this.renderContent(this.state.selectedView)}
            </div>
            
            </div>
        )
    }
}

export default Stress; 